export const NORSKE_FORNAVN: readonly string[] = [
  'Hilde',
  'Bjørn',
  'Astrid',
  'Henrik',
  'Marit',
  'Kjell',
  'Solveig',
  'Lars',
  'Ingrid',
  'Erik',
  'Sigrid',
  'Tor',
  'Liv',
  'Magnus',
  'Anne',
  'Pål',
  'Kari',
  'Jon',
  'Tone',
  'Sverre',
  'Synnøve',
  'Espen',
  'Randi',
  'Halvor',
  'Frida',
  'Vegard',
  'Mette',
  'Trygve',
  'Aslaug',
  'Eirik',
  'Maren',
  'Olav',
];

export const NORSKE_ETTERNAVN: readonly string[] = [
  'Berg',
  'Lund',
  'Solheim',
  'Haugen',
  'Strand',
  'Dahl',
  'Bakken',
  'Nilsen',
  'Eriksen',
  'Olsen',
  'Aas',
  'Vik',
  'Moe',
  'Lien',
  'Holm',
  'Sandvik',
  'Fjellstad',
  'Rødland',
  'Tønnesen',
  'Kristoffersen',
  'Halvorsen',
  'Bråten',
  'Engebretsen',
  'Myhre',
  'Skogen',
  'Tveit',
  'Furuseth',
  'Aune',
  'Krogh',
  'Næss',
  'Borgen',
  'Hovland',
];
